module.exports = __webpack_public_path__ + "img/waves.28cfefb5.svg";